import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CustomPagination from "Common/customPagination";
import { authServices } from "Utils/auth/services";
import FancyPLMarketWiseTableEventTable from "Common/Tables/eventPlTables/PlMarketWiseTable";

interface EventPlPayload {
  search: {
    match_name: string;
    match_id: string;
    type: string;
  };
  from_date: string;
  to_date: string;
  page: number;
  limit: number;
}


const PlMarketWiseEventPl: React.FC = () => {
//   const { sport_id, sport_name, from_date, to_date, type } = useParams<any>();
//   "/plMarketwise/:marketid/:matchname/:type/:sportid/:from_date/:to_date/",
  const { marketid, matchname, type, sportid, from_date, to_date } = useParams<any>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(50);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const getEventPlData = async (page: number = 1) => {
    if (!sportid || !from_date || !to_date || !type) return;

    setIsLoading(true);
    try {
      const payload: EventPlPayload = {
        search: {
          match_name: String(matchname),
          match_id: String(marketid),
          type: type,
        },
        from_date: from_date,
        to_date: to_date,
        page,
        limit: itemsPerPage,
      };

      const { response } = await authServices.getPlMarketWise(payload);
      const metadata = response?.metadata;

      if (response?.data) {
        setCasinoBetsData(response.data?.data);
        setTotalItems(metadata?.[0]?.total || 0);
      } else {
        setCasinoBetsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching casino bets data:", error);
      setCasinoBetsData([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getEventPlData(page);
  };

  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    getEventPlData(1);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredData = searchTerm
    ? casinoBetsData.filter((item) =>
        item.match_name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
        item.sport_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.event_name?.toLowerCase().includes(searchTerm.toLowerCase()) 
      )
    : casinoBetsData;

  useEffect(() => {
    getEventPlData(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sportid, from_date, to_date, type, itemsPerPage]);
  const handleRowClick = (event_id:String, type:String) => {
  
  
    const url = `/pl-Userwise/${sportid}/${event_id}/${type}`;
    // // navigate(url);
    window.open(url, "_blank");

    
};
  return (
    <div className="event-pl">
      <Card>
        <Card.Body>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 align-items-center">
              Show
              <select
                className="form-select w-auto"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
              Entries
            </div>

            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="w-25"
            />
          </div>

          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <FancyPLMarketWiseTableEventTable fancyPLData={filteredData}     onClickRow={handleRowClick}/>
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
           
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PlMarketWiseEventPl;
